import { ChangeEvent } from 'react'
import { useTranslation } from 'next-i18next'

import { BookingLanguage } from '~/types/booking'
import { SelectBoxHomGradient } from '~/components/SelectBoxHomGradient'

export default function SelectLanguage<T extends BookingLanguage | null>({
  onChange,
  language,
  error = '',
}: {
  onChange: (language: T) => void
  language: T
  error?: string | undefined
}): React.ReactElement {
  const { t } = useTranslation('booking')

  const handleOnChange = (event: ChangeEvent<HTMLSelectElement>): void => {
    onChange((event.target.value || null) as T)
  }

  return (
    <SelectBoxHomGradient
      error={error}
      isSelected={Boolean(language)}
      name="language"
      onChange={handleOnChange}
      value={language ?? ''}
    >
      <option value="">{t('tutoringLanguage')}</option>
      {Object.values(BookingLanguage).map((elem) => (
        <option key={elem} value={elem}>
          {t(`languages.${elem}`)}
        </option>
      ))}
    </SelectBoxHomGradient>
  )
}
